import axios from '@/config/axiosInterceptor'

export const switchLocation = (hotel_id: string) => {
  return axios.put(`switchLocation/${hotel_id}`)
}
